import * as React from 'react';
import { Link } from 'react-scroll';
import * as styles from './Nav.css';
import { HEADER_REF } from './Header';
import { WORK_REF, HACKS_REF, TALKS_REF, VOLUNTEER_REF } from './App';
import Sticky from 'react-stickynode';

export class Nav extends React.Component {
    render() {
        return (
            <Sticky>
                <nav className={styles.nav}>

                    <Link
                        activeClass={styles.active}
                        className={styles.link}
                        to={HEADER_REF}
                        spy={true}
                        smooth={true}
                        duration={500}
                    >
                        Hello World
                    </Link>

                    <Link
                        activeClass={styles.active}
                        className={styles.link}
                        to={WORK_REF}
                        spy={true}
                        smooth={true}
                        duration={500}
                    >
                        Projects
                    </Link>

                    <Link
                        activeClass={styles.active}
                        className={styles.link}
                        to={HACKS_REF}
                        spy={true}
                        smooth={true}
                        duration={500}
                    >
                        Hacks
                    </Link>

                    <Link
                        activeClass={styles.active}
                        className={styles.link}
                        to={TALKS_REF}
                        spy={true}
                        smooth={true}
                        duration={500}
                    >
                        Talks
                    </Link>
                    <Link
                        activeClass={styles.active}
                        className={styles.link}
                        to={VOLUNTEER_REF}
                        spy={true}
                        smooth={true}
                        duration={500}
                    >
                        Volunteer
                    </Link>
                </nav>
            </Sticky >
        );
    }
} 


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Nav.tsx